import { render, staticRenderFns } from "./BulkVehicleSelectModal.vue?vue&type=template&id=3a1bc875&scoped=true"
import script from "./BulkVehicleSelectModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BulkVehicleSelectModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1bc875",
  null
  
)

export default component.exports